import React, { useEffect } from 'react';
import { Lock } from 'lucide-react';
import { AUTH_REQUIRED_MESSAGE, dispatchAuthRequired } from '../../utils/authPrompt';

interface AuthRequiredStateProps {
  title?: string;
  description?: string;
}

const AuthRequiredState: React.FC<AuthRequiredStateProps> = ({
  title = AUTH_REQUIRED_MESSAGE,
  description = '登录后即可查看试稿、合同、消息等专属内容。'
}) => {
  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      dispatchAuthRequired({ showToast: false, reason: 'route-guard' });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <div className="min-h-[calc(100vh-96px)] flex flex-col items-center justify-center bg-[#FDFDFD] px-6 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-slate-100">
        <Lock className="h-8 w-8 text-slate-400" />
      </div>
      <h2 className="text-3xl font-bold tracking-tight text-slate-900">
        {title}
      </h2>
      <p className="mt-3 max-w-md text-sm leading-7 text-slate-500">
        {description}
      </p>
      <button
        type="button"
        onClick={() => dispatchAuthRequired({ showToast: false, reason: 'route-guard' })}
        className="mt-8 rounded-2xl bg-black px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-gray-800"
      >
        立即登录
      </button>
    </div>
  );
};

export default AuthRequiredState;
